// extracted by mini-css-extract-plugin
export default {"cls1":"AiSummary-cls1__wz","cls2":"AiSummary-cls2_wMk AiSummary-cls1__wz","type-finding":"AiSummary-type-finding_qkq","type-figure":"AiSummary-type-figure_l6q"};